import { useState } from 'react';
import { AppButton, AppFlex, AppText, AppTitle, DetailsFrameBase } from 'components/atoms';

import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { IconDownload, IconFileInvoice } from '@tabler/icons-react';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { downloadFileFromBase64 } from 'utils/fileDownload';
import { settlementTexts } from 'consts/text/index';
import { Card, Col, Row } from 'antd';
import styled from 'styled-components';
import { If } from '../../../atoms/If/If';
import ParentHTTPService from '../../../../services/HTTPService/parent/ParentHTTPService';

const ItemContainer = styled.div`
    margin-block-start: 32px;
    margin-top: 32px;
`;

type ChildInvoicesProps = {
    correctionId: string;
    isParent?: boolean;
    fileName?: string;
    title?: string;
};

export const ChildCorrectionInvoices = ({
    correctionId,
    isParent = false,
    fileName,
    title,
}: ChildInvoicesProps) => {
    const { displayError } = useSimpleNotification();
    const [downloadingCorrectionIdId, setDownloadingCorrectionIdId] = useState<string | null>(null);

    const handleDownloadInvoice = async () => {
        try {
            setDownloadingCorrectionIdId(correctionId);
            const response = isParent
                ? await ParentHTTPService.settlements.getCorrectionInvoices(correctionId)
                : await StaffHTTPService.invoices.getCorrectionInvoices(correctionId);

            downloadFileFromBase64(response.data, fileName ?? 'no_file.pdf');
        } catch (error) {
            displayError(settlementTexts.children.invoices.downloadError);
            console.error('Error downloading invoice:', error);
        } finally {
            setDownloadingCorrectionIdId(null);
        }
    };

    if (!fileName) {
        return (
            <ItemContainer>
                <DetailsFrameBase hideHeader>
                    <AppText>Brak dostępnych faktur dla tego rozliczenia</AppText>
                </DetailsFrameBase>
            </ItemContainer>
        );
    }

    return (
        <ItemContainer>
            <If condition={title}>
                <AppTitle level={4} style={{ marginBottom: 16 }}>
                    <IconFileInvoice style={{ marginRight: 8 }} />
                    {title}
                </AppTitle>
            </If>

            <Row gutter={[16, 16]}>
                <Col xs={24}>
                    <Card
                        title={
                            <AppFlex align="center" gap="small">
                                <IconFileInvoice size={16} />
                                <AppText>{'Korekta'}</AppText>
                            </AppFlex>
                        }
                        extra={
                            <AppButton
                                type="link"
                                size="small"
                                icon={<IconDownload size={16} />}
                                loading={!!downloadingCorrectionIdId}
                                onClick={() => handleDownloadInvoice()}
                            >
                                Pobierz
                            </AppButton>
                        }
                    >
                        <AppText textType="BodySmall" color="secondary">
                            {fileName ?? 'Invoice nnumer'}
                        </AppText>
                        <br />
                    </Card>
                </Col>
            </Row>
        </ItemContainer>
    );
};
